module.exports = {"en-US":{"components":{"proposal-overlay":{"info":{"title":"Vendor details"}}}}}